// socket.js
import { io } from 'socket.io-client';

// Initialize socket connection
const socket = io(process.env.REACT_APP_API_SOCKET_URL, {
  transports: ['websocket'],
});

export default socket;